// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"4e034a10","685":"4e034a10","2440":"4e034a10","3520":"4e034a10","5850":"4e034a10","6291":"4e034a10","8723":"4e034a10","9277":"4e034a10"}[chunkId] + ".chunk.css";
};